// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const soldier = defineModel({
  id: "soldier",
  batchId: "future",
  name: "Soldier",
  tags: ["creature","soldier","low-poly","age-of-mcp","future","military"],
  summary: "An armed soldier figure (parked: there is no combat system today).",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.018, 0.016, 0.09, 5), color: "#4a443c", position: [0.012, 0.05, 0.025] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.016, 0.09, 5), color: "#4a443c", position: [0.012, 0.05, -0.025] },
      { geometry: new THREE.BoxGeometry(0.04, 0.02, 0.03), color: "#3a352f", position: [0.02, 0.01, 0.025] },
      { geometry: new THREE.BoxGeometry(0.04, 0.02, 0.03), color: "#3a352f", position: [0.02, 0.01, -0.025] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.07), color: "#7c8088", position: [0.01, 0.14, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.09, 0.075), color: "#9d3530", position: [0.012, 0.145, 0] },
      { geometry: new THREE.CylinderGeometry(0.016, 0.014, 0.08, 5), color: "#7c8088", position: [0, 0.13, 0.055], rotation: [0, 0, 0.1] },
      { geometry: new THREE.CylinderGeometry(0.016, 0.014, 0.08, 5), color: "#5e6168", position: [0, 0.13, -0.055], rotation: [0, 0, 0.1] },
      { geometry: new THREE.SphereGeometry(0.026, 6, 5), color: "#caa07a", position: [0.012, 0.215, 0] },
      { geometry: new THREE.SphereGeometry(0.03, 6, 5, 0, 6.283185, 0, 1.847996), color: "#9aa0a6", position: [0.012, 0.222, 0] },
      { geometry: new THREE.BoxGeometry(0.012, 0.03, 0.008), color: "#6f757b", position: [0.036, 0.205, 0] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.34, 5), color: "#7a522e", position: [0.04, 0.18, 0.06] },
      { geometry: new THREE.ConeGeometry(0.014, 0.05, 5), color: "#cdd2d6", position: [0.04, 0.37, 0.06] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.014, 10), color: "#5e6168", position: [-0.02, 0.15, -0.07], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.SphereGeometry(0.012, 6, 5), color: "#cdd2d6", position: [-0.027, 0.15, -0.07] },
    ],
  animations: [],
});
